import Vue from 'vue'
import Clipboard from 'clipboard'

function clipboardSuccess(options) {
    console.log(options)
    if (typeof options === 'string') options = { content: options };
    options = { duration: 3, content: 'Copy successfully', ...options };
    Vue.prototype.$ivMessage.success(options);
}

function clipboardError(options) {
    if (typeof options === 'string') options = { content: options };
    options = { duration: 3, content: '复制失败', ...options };
    Vue.prototype.$ivMessage.error(options);
}

export default function handleClipboard(text, event, content) {
    const clipboard = new Clipboard(event.target, {
        text: () => text
    })
    clipboard.on('success', () => {
        console.log(content)
        clipboardSuccess(content)
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
    })
    clipboard.on('error', () => {
        clipboardError()
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
    })
    clipboard.onClick(event)
}
